'use strict';

var $ = window.jQuery;

/**
 * Sends JQuery events when RichFaces / A4J does an ajax request
 */
if (typeof A4J !== 'undefined' && A4J.AJAX) {

	var listeners = {
		queueonsubmit: function(request) {
			if (request.domEvt.target != null) {
				$(request.domEvt.target).parents('form').trigger('ajaxSend');
			}
			//return false;
		},
		queueoncomplete: function(request, event, data) {
			$(document).trigger('ajaxSuccess');
			$(document).trigger('ajaxComplete');
		},
		queueonerror: function(request, status, message) {
			$(document).trigger('ajaxError');
			$(document).trigger('ajaxComplete');
		}
	};
	A4J.AJAX.EventQueue.addQueue(new A4J.AJAX.EventQueue('org.richfaces.queue.global', null, listeners));
}